import { Button, Select } from '@/components'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { useAppSelector } from '@/redux/hooks'
import { Editor } from '@toast-ui/react-editor'
import { useEffect, useRef, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import {
  emailInfo,
  FeedbackInsertData,
  FeedbackType,
  fieldCheck,
  PraiseInfo,
  SuggestionInfo,
  UploadInfo,
} from '../feedbackItem'
import {
  buttonName,
  confirmMessages,
  errorMessages,
} from '@/pages/board/boardItem'
import codeSyntaxHighlight from '@toast-ui/editor-plugin-code-syntax-highlight'
import colorSyntax from '@toast-ui/editor-plugin-color-syntax'
import { GolfBizNm } from '@/pages/promotion/promotionItem'
import FileUpload from './fileUpload'
import { FileUploadResponse } from '@/pages/blog/blogItem'
import { useResponsive } from '@/hooks/useResponsive'

type TInput = HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement

type FeedbackEditorProps = {
  nameList: GolfBizNm[]
}

type FormData = {
  nttSj: string
  nttCn: string
  rndDt: string
}

export const FeedbackEditor = ({ nameList }: FeedbackEditorProps) => {
  const axios = useAxios()
  const navigate = useNavigate()
  const location = useLocation()
  const { user } = useAppSelector((state) => state.auth)
  const { showAlert, showConfirm } = useDialog()
  const editorRef = useRef<Editor>(null)

  //파일업로드 상태관리
  const [fileSeqList, setFileSeqList] = useState<number[]>([])
  const [fileNameList, setFileNameList] = useState<string[]>([])
  const [fileSourceList, setFileSourList] = useState<string[]>([])
  const [deleteSeqList, setDeleteSeqList] = useState<number[]>([])
  const [deleteNameList, setDeleteNameList] = useState<string[]>([])
  const [resetUploadTrigger, setResetUploadTrigger] = useState(false)
  // 에디터 내 이미지와 파일 seq 매핑을 위한 상태 추가
  const [editorImageMap, setEditorImageMap] = useState<
    Map<string, { seq: number; name: string }>
  >(new Map())
  //파일 선택 상태를 관리하는 state 추가
  const [hasUnuploadedFiles, setHasUnuploadedFiles] = useState(false)
  const { isMobile, isTablet, isDesktop } = useResponsive()
  const [formData, setFormData] = useState<FeedbackInsertData>({
    cmpnyCd: '001',
    cstId: user?.cstId || '',
    nttSn: 0,
    regId: user?.cstId || '',
    regDate: '',
    updId: user?.cstId || '',
    updDate: '',
    bizCd: '',
    fdbkType: '01',
    email: '',
    nttSj: '',
    nttCn: '',
    page: 1,
    fileSeqList: fileSeqList,
    fileNameList: fileNameList,
    fileSourceList: fileSourceList, // 추가
    deleteSeqList: deleteSeqList,
    rndDt: '',
  })

  // useEffect(() => {
  //   console.log('fileSeqList 변경', fileSeqList)
  // }, [fileSeqList])

  // useEffect(() => {
  //   console.log('fileNameList 변경', fileNameList)
  // }, [fileNameList])

  // useEffect(() => {
  //   console.log('fileSourceList 변경', fileSourceList)
  // }, [fileSourceList])

  // 에디터 이미지와 파일 업로드를 합쳐서 fileSeqList, fileSourceList 생성
  // useEffect(() => {
  //   // 파일 업로드 중에서 삭제되지 않은 것들
  //   const validUploadedSeqs = uploadedFileSeqs.filter(
  //     (seq) => !deletedFileSeqs.includes(seq),
  //   )

  //   // 에디터 이미지 + 파일 업로드를 합쳐서 최종 fileSeqList 생성
  //   const allSeqs = [...editorImageSeqs, ...validUploadedSeqs]
  //   const uniqueSeqs = Array.from(new Set(allSeqs)) // 중복 제거

  //   // fileSource 배열도 함께 생성
  //   const sources: string[] = []
  //   editorImageSeqs.forEach(() => sources.push('EDITOR'))
  //   validUploadedSeqs.forEach(() => sources.push('UPLOAD'))

  //   setFileSeqList(uniqueSeqs)
  //   setFileSourceList(sources)
  // }, [editorImageSeqs, uploadedFileSeqs, deletedFileSeqs])

  useEffect(() => {
    if (editorRef.current) {
      const editorInstance = editorRef.current.getInstance()

      // 에디터에서 키 이벤트 감지 (Delete, Backspace)
      editorInstance.addHook('keydown', (keyEvent: KeyboardEvent) => {
        if (keyEvent.key === 'Delete' || keyEvent.key === 'Backspace') {
          // 키 이벤트 후 잠시 대기한 후 삭제된 이미지 체크
          setTimeout(() => {
            checkDeletedImagesInEditor()
          }, 100)
        }
      })

      // 에디터 내용이 직접 변경되었을 때도 체크
      editorInstance.addHook('change', () => {
        setTimeout(() => {
          checkDeletedImagesInEditor()
        }, 100)
      })
    }
  }, [editorImageMap, fileSeqList]) // editorImageMap과 fileSeqList가 변경될 때마다 재등록

  // useEffect(() => {
  //   // 시작날짜 오늘날짜로 셋팅
  //   if (!formData.rndDt) {
  //     const today = new Date()
  //     const yyyy = today.getFullYear()
  //     const mm = String(today.getMonth() + 1).padStart(2, '0')
  //     const dd = String(today.getDate()).padStart(2, '0')
  //     const todayStr = `${yyyy}-${mm}-${dd}`

  //     setFormData((prev) => ({
  //       ...prev,
  //       rndDt: todayStr,
  //     }))
  //   }
  // }, [])

  useEffect(() => {
    if (nameList.length > 0 && !formData.bizCd) {
      setFormData((prev) => ({
        ...prev,
        //bizCd: nameList[0].bizCd,
      }))
    }
  }, [nameList])

  // 추가로 useEffect로 deleteSeqList 변경사항 모니터링
  // useEffect(() => {
  //   console.log('=== deleteSeqList 변경됨 ===')
  //   console.log('현재 deleteSeqList:', deleteSeqList)
  //   console.log('현재 deleteNameList:', deleteNameList)
  // }, [deleteSeqList, deleteNameList])

  // formData 업데이트에도 deleteSeqList 포함하기
  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      fileSeqList: fileSeqList,
      fileNameList: fileNameList,
      fileSourceList: fileSourceList,
      deleteSeqList: deleteSeqList,
    }))
  }, [fileSeqList, fileNameList, fileSourceList, deleteSeqList]) // deleteSeqList 의존성 추가

  //

  useEffect(() => {
    console.log('========== 디버깅 시작 ==========')
    console.log('isMobile:', isMobile)
    console.log('isTablet:', isTablet)
    console.log('isDesktop:', isDesktop)
    console.log('window.innerWidth:', window.innerWidth)
    console.log('editorRef.current:', editorRef.current)
    console.log('================================')
    // 약간의 지연을 두고 실행 (에디터가 완전히 마운트될 때까지)
    const timer = setTimeout(() => {
      console.log('🔍 useEffect 실행 - editorRef:', editorRef.current)
      console.log('🔍 isMobile:', isMobile)

      if (editorRef.current) {
        console.log('✅ Editor 인스턴스 획득')

        editorRef.current
          .getInstance()
          .addHook(
            'addImageBlobHook',
            async (
              blob: Blob,
              callback: (url: string, altText: string) => void,
            ) => {
              console.log('🔥 addImageBlobHook 실행됨!', blob)
              console.log('🔥 isMobile:', isMobile)

              const maxFileSize = 10 * 1024 * 1024 // 10MB

              if (blob.size > maxFileSize) {
                showAlert({
                  title: '10MB 이상의 파일은 업로드 할 수 없어요.',
                  message: `파일 크기가 ${(blob.size / (1024 * 1024)).toFixed(2)}MB 에요.`,
                })
                return
              }

              const { fileSeq, fileUrl } = await uploadImageToServer(blob)

              if (fileUrl) {
                callback(fileUrl, '')

                const editorInstance = editorRef.current?.getInstance()
                const currentHTML = editorInstance?.getHTML()

                if (!currentHTML) return

                let fixedHTML = currentHTML.replace(
                  /<p>([^<]*?)?(<img[^>]+><br>)([^<]*)?<\/p>/g,
                  (_, textBefore, imgTag, textAfter) => {
                    const parts = []
                    if (textBefore?.trim()) parts.push(`<p>${textBefore}</p>`)
                    parts.push(`<p>${imgTag}</p>`)
                    if (textAfter?.trim()) parts.push(`<p>${textAfter}</p>`)
                    return parts.join('')
                  },
                )

                // style 속성 제거
                fixedHTML = fixedHTML.replace(
                  /<img([^>]*)\s+style="[^"]*"([^>]*)>/g,
                  '<img$1$2>',
                )

                if (fixedHTML.match(/<p><img[^>]+><br><\/p>$/)) {
                  fixedHTML += '<p></p>'
                }

                editorInstance?.setHTML(fixedHTML)
              }
              return false
            },
          )
      } else {
        console.log('❌ editorRef.current가 null')
      }
    }, 200) // 200ms 지연

    return () => clearTimeout(timer)
  }, [isMobile]) // isMobile 의존성 추가

  // 피드백 타입에 따른 CSS 클래스 결정
  const getContainerClassName = () => {
    const baseClass = 'feedback-edit-container'
    const typeClass = formData.fdbkType
      ? `type-${formData.fdbkType}`
      : 'type-01'
    return `${baseClass} ${typeClass}`
  }

  const handleChange = (e: React.ChangeEvent<TInput>) => {
    const { name, value, type, checked } = e.target as HTMLInputElement

    if (name === 'rndDt') {
      if (new Date(value) > new Date()) {
        showAlert({
          type: 'error',
          title: '오늘 이전 날짜만 선택할 수 있어요.',
        })
        return
      }
    }

    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }))
  }

  // 에디터 내용
  const handleEditorChange = () => {
    const editorNttCn = editorRef.current?.getInstance()
    if (editorNttCn) {
      const nttCn = editorNttCn.getHTML()
      setFormData((prev) => ({ ...prev, nttCn }))

      // 에디터 내용이 변경될 때마다 삭제된 이미지 체크
      setTimeout(() => {
        checkDeletedImagesInEditor()
      }, 100)
    }
  }

  //저장전 체크
  const handleModalAction = (type: 'insert' | 'cancel') => {
    if (type === 'insert') {
      const requiredFields: { field: keyof FormData; message: string }[] = [
        { field: 'nttSj', message: fieldCheck.nttSj },
        { field: 'nttCn', message: fieldCheck.nttCn },
        { field: 'rndDt', message: fieldCheck.rndDt },
      ]

      for (const { field, message } of requiredFields) {
        const value = formData[field]

        if (field === 'nttCn') {
          // nttCn이 HTML 형태일 경우, 이미지 태그는 허용하고 나머지 태그는 제거
          const strippedText = value
            ?.replace(/<(?!img\s*[^>]*>)[^>]+>/g, ' ')
            .trim() // img 태그를 제외한 나머지 HTML 태그 제거

          // 내용이 없거나 공백만 있는 경우
          if (
            strippedText === '' ||
            strippedText?.replace(/\s+/g, '').length === 0
          ) {
            showAlert({
              type: 'warning',
              title: message,
            })
            return
          }
        } else if (typeof value === 'string' && !value.trim()) {
          showAlert({
            type: 'warning',
            title: message,
          })
          return
        }

        if (!formData[field]) {
          showAlert({
            type: 'warning',
            title: message,
          })
          return
        }
      }

      // 업로드되지 않은 파일이 있는지 확인
      if (hasUnuploadedFiles) {
        showAlert({
          type: 'warning',
          title: '선택된 파일을 먼저 업로드해주세요.',
        })
        return
      }

      // 라운드 인증 이미지 업로드 체크 추가
      if (fileSeqList.length === 0) {
        showAlert({
          type: 'warning',
          title: '라운드 인증 이미지를 업로드해주세요.',
        })
        return
      }

      showConfirm({
        title: confirmMessages.insert,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          insertFeedback()
        },
      })
    }

    if (type === 'cancel') {
      showConfirm({
        title: confirmMessages.cancel,
        confirmBtnName: buttonName.confirm,
        cancelBtnName: buttonName.cancel,
        onConfirm() {
          setTimeout(() => {
            navigate(`/feedback`, { state: location.state })
          }, 100)
        },
      })
    }
  }

  const handleUploadedFile = (
    uploadSeqs: number[],
    uploadNames: string[],
    uploadSources: string[],
  ) => {
    setFileSeqList((prev) => {
      const newList = [...prev, ...uploadSeqs]
      return newList
    })

    setFileNameList((prev) => {
      const newList = [...prev, ...uploadNames]
      return newList
    })
    setFileSourList((prev) => {
      const newList = [...prev, ...uploadSources]
      return newList
    })
  }

  const handleDeletedFile = (fileSeqs: number[], fileNames: string[]) => {
    // 삭제 리스트 업데이트
    setDeleteSeqList(fileSeqs)
    setDeleteNameList(fileNames)

    // fileSeqList에서 삭제된 파일들 제거
    setFileSeqList((prev) => {
      const filtered = prev.filter((seq) => !fileSeqs.includes(seq))
      return filtered
    })

    // fileNameList에서도 삭제된 파일명들 제거
    setFileNameList((prev) => {
      const filtered = prev.filter((name) => !fileNames.includes(name))
      return filtered
    })

    // fileSourceList에서도 해당 인덱스의 소스들 제거
    setFileSourList((prev) => {
      // 삭제된 fileSeq들의 인덱스를 찾아서 해당 소스들 제거
      const newSources = prev.filter((source, index) => {
        const currentSeq = fileSeqList[index]
        return !fileSeqs.includes(currentSeq)
      })
      return newSources
    })
  }

  // 기존 uploadImageToServer 함수 수정
  const uploadImageToServer = async (
    blob: Blob,
  ): Promise<{
    fileUrl: string
    fileSeq: number | null
    fileSource: string
  }> => {
    const formData = new FormData()
    formData.append('file', blob)

    try {
      const response = await axios.post<{ data: FileUploadResponse }>(
        '/feedback/fileUpload',
        formData,
        {
          headers: { 'Content-Type': 'multipart/form-data' },
        },
      )

      const fileUrl =
        process.env.REACT_APP_BASE_URL + '/upload/' + response.data.data.fileNm
      const fileSeq = response.data.data.fileSeq
      const fileName = response.data.data.fileNm
      const fileSource = 'EDITOR'

      // 에디터 이미지 매핑 정보 저장 (URL을 키로 사용)
      setEditorImageMap((prev) => {
        const newMap = new Map(prev)
        newMap.set(fileUrl, { seq: fileSeq, name: fileName })
        return newMap
      })

      setFileSeqList((prev) => [...prev, fileSeq])
      setFileNameList((prev) => [...prev, fileName])
      setFileSourList((prev) => [...prev, fileSource])

      return { fileUrl, fileSeq, fileSource }
    } catch (error) {
      showAlert({
        title: '이미지 업로드 실패',
        message: error,
        btnName: '확인',
      })
      return { fileUrl: '', fileSeq: null, fileSource: '' }
    }
  }

  // 에디터 내용 변경 감지하여 삭제된 이미지 찾기
  const checkDeletedImagesInEditor = () => {
    if (!editorRef.current) return

    const currentHTML = editorRef.current.getInstance().getHTML()
    const currentImageUrls = new Set<string>()

    // 현재 에디터에 있는 이미지 URL들 추출
    const imgRegex = /<img[^>]+src="([^"]+)"/g
    let match
    while ((match = imgRegex.exec(currentHTML)) !== null) {
      currentImageUrls.add(match[1])
    }

    // 매핑된 이미지 중에서 현재 에디터에 없는 것들 찾기
    const deletedImages: { seq: number; name: string }[] = []

    editorImageMap.forEach((imageInfo, imageUrl) => {
      if (!currentImageUrls.has(imageUrl)) {
        deletedImages.push(imageInfo)
      }
    })

    if (deletedImages.length > 0) {
      // 삭제된 이미지들을 삭제 목록에 추가
      const deletedSeqs = deletedImages.map((img) => img.seq)
      const deletedNames = deletedImages.map((img) => img.name)

      setDeleteSeqList((prev) => {
        const newList = [...prev, ...deletedSeqs]
        return Array.from(new Set(newList)) // 중복 제거
      })

      setDeleteNameList((prev) => {
        const newList = [...prev, ...deletedNames]
        return Array.from(new Set(newList)) // 중복 제거
      })

      // fileSeqList와 fileNameList에서도 제거
      setFileSeqList((prev) => prev.filter((seq) => !deletedSeqs.includes(seq)))
      setFileNameList((prev) =>
        prev.filter((name) => !deletedNames.includes(name)),
      )
      setFileSourList((prev) => {
        return prev.filter((source, index) => {
          const currentSeq = fileSeqList[index]
          return !deletedSeqs.includes(currentSeq)
        })
      })

      // 매핑에서도 삭제된 이미지들 제거
      setEditorImageMap((prev) => {
        const newMap = new Map(prev)
        deletedImages.forEach((img) => {
          // URL을 키로 찾아서 삭제
          for (const [url, info] of newMap.entries()) {
            if (info.seq === img.seq) {
              newMap.delete(url)
              break
            }
          }
        })
        return newMap
      })
    }
  }

  const insertFeedback = async () => {
    const finalUploadFileSeqs = fileSeqList.filter(
      (seq) => !deleteSeqList.includes(seq),
    )

    const insertData = {
      ...formData,
      //deleteFileSeqList: deleteSeqList, // 삭제할 파일 목록
    }

    try {
      await axios.post(`/feedback/insert`, insertData)

      setTimeout(() => {
        navigate(`/feedback`, { state: location.state })
      }, 300)
    } catch (err: any) {
      showAlert({
        type: 'error',
        title: errorMessages.insert,
        message: err.response?.data?.message,
        btnName: buttonName.confirm,
      })
    }
  }

  const handleFileSelectionChange = (hasSelectedFiles: boolean) => {
    setHasUnuploadedFiles(hasSelectedFiles)
  }

  return (
    <>
      {!isMobile ? (
        <>
          <div className={getContainerClassName()}>
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className="radio-group">
                <label className="required-label">종류</label>
                <Select
                  id="fdbkType"
                  name="fdbkType"
                  width="100px"
                  value={formData.fdbkType}
                  onChange={handleChange}
                  style={{ marginLeft: '8px' }}
                >
                  {FeedbackType.map((type, index) => (
                    <option key={`${type}-${index}`} value={type.value}>
                      {type.label}
                    </option>
                  ))}
                </Select>
              </div>
            </div>
            {formData.fdbkType === '01' && <PraiseInfo />}
            {formData.fdbkType === '02' && <SuggestionInfo />}
            <div style={{ display: 'flex', gap: '20px' }}>
              <div className="radio-group">
                <label className="required-label">라운드골프장</label>
                <Select
                  id="bizCd"
                  name="bizCd"
                  width="400px"
                  value={formData.bizCd}
                  onChange={handleChange}
                  style={{ marginLeft: '8px' }}
                >
                  <option value="">선택하세요.</option>
                  {nameList.map((option, index) => (
                    <option
                      key={`${option.areaCd}-${index}`}
                      value={option.bizCd}
                    >
                      {option.bizNm}
                    </option>
                  ))}
                </Select>
              </div>
              <div className="radio-group">
                <label className="required-label">라운드날짜</label>
                <input
                  type="date"
                  id="rndDt"
                  name="rndDt"
                  width="400px"
                  value={formData.rndDt}
                  onChange={handleChange}
                />
              </div>
            </div>
            <div className="radio-group">
              <label className="required-label">라운드 인증 이미지</label>
              <div className="upload-wrapper">
                <FileUpload
                  onDeletedFile={handleDeletedFile}
                  onUploadedFile={handleUploadedFile}
                  onFileSelectionChange={handleFileSelectionChange}
                  resetUploadTrigger={resetUploadTrigger}
                />
              </div>
            </div>
            <UploadInfo />
            <div className="radio-group">
              <label className="required-label">제목</label>
              <input
                type="text"
                name="nttSj"
                maxLength={255}
                value={formData.nttSj}
                onChange={handleChange}
                width={'100%'}
              />
            </div>
            <Editor
              ref={editorRef}
              useCommandShortcut={true}
              placeholder="내용을 입력해 주세요!"
              previewStyle="vertical" // 미리보기 스타일 지정
              height="500px" // 에디터 창 높이
              initialEditType="wysiwyg" // 초기 입력모드 설정 (기본 markdown)
              onChange={handleEditorChange}
              language="ko-KR"
              hideModeSwitch={true} // 하단의 타입 선택 탭 숨기기
              plugins={[colorSyntax, codeSyntaxHighlight]}
            />
            <div className="edit-group">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <label style={{ marginRight: '20px' }}>e-mail</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  maxLength={255}
                  value={formData.email}
                  onChange={handleChange}
                />
                <span className="hint-text">{emailInfo}</span>
              </div>
            </div>
          </div>
          <div className="feedback-button">
            <Button color="neverbe" onClick={() => handleModalAction('insert')}>
              저장
            </Button>
            <Button color="neverbe" onClick={() => handleModalAction('cancel')}>
              취소
            </Button>
          </div>
        </>
      ) : (
        <>
          <div className="blog-write-container">
            <div className="blog-write-header">
              <h1 className="blog-write-title">목소리</h1>
              <button
                className="blog-back-btn"
                onClick={() => handleModalAction('cancel')}
              >
                ← 뒤로
              </button>
            </div>
            <div className="blog-write-card">
              <form className={getContainerClassName()} style={{ gap: '0px' }}>
                <div className="blog-form-row">
                  <div className="blog-form-group category">
                    <label className="mobile-fb-write-form-label mobile-fb-write-required">
                      종류
                    </label>
                    <select
                      className="blog-form-select"
                      id="fdbkType"
                      name="fdbkType"
                      value={formData.fdbkType}
                      onChange={handleChange}
                    >
                      {FeedbackType.map((type, index) => (
                        <option key={`${type}-${index}`} value={type.value}>
                          {type.label}
                        </option>
                      ))}
                    </select>
                  </div>
                  {formData.fdbkType === '01' && (
                    <PraiseInfo isMobile={isMobile} />
                  )}
                  {formData.fdbkType === '02' && (
                    <SuggestionInfo isMobile={isMobile} />
                  )}
                  <div className="blog-form-group category">
                    <label className="mobile-fb-write-form-label mobile-fb-write-required">
                      라운드골프장
                    </label>
                    <select
                      className="blog-form-select"
                      id="bizCd"
                      name="bizCd"
                      value={formData.bizCd}
                      onChange={handleChange}
                      required
                    >
                      <option value="">선택하세요.</option>
                      {nameList.map((option, index) => (
                        <option
                          key={`${option.areaCd}-${index}`}
                          value={option.bizCd}
                        >
                          {option.bizNm}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="blog-form-group category">
                    <label className="mobile-fb-write-form-label mobile-fb-write-required">
                      라운드날짜
                    </label>
                    <input
                      type="date"
                      id="rndDt"
                      name="rndDt"
                      value={formData.rndDt}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="blog-form-group category">
                    <label className="mobile-fb-write-form-label mobile-fb-write-required">
                      라운드 인증 이미지
                    </label>
                    <FileUpload
                      onDeletedFile={handleDeletedFile}
                      onUploadedFile={handleUploadedFile}
                      onFileSelectionChange={handleFileSelectionChange}
                      resetUploadTrigger={resetUploadTrigger}
                    />
                  </div>
                  <div className="blog-form-group title">
                    <label className="mobile-fb-write-form-label mobile-fb-write-required">
                      제목
                    </label>
                    <input
                      type="text"
                      className="blog-form-input"
                      id="nttSj"
                      name="nttSj"
                      placeholder="제목을 입력하세요"
                      value={formData.nttSj}
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="blog-form-group">
                  <Editor
                    ref={editorRef}
                    useCommandShortcut={true}
                    placeholder="내용을 입력해 주세요!"
                    previewStyle="vertical" // 미리보기 스타일 지정
                    height="500px" // 에디터 창 높이
                    initialEditType="wysiwyg" // 초기 입력모드 설정 (기본 markdown)
                    onChange={handleEditorChange}
                    language="ko-KR"
                    hideModeSwitch={true} // 하단의 타입 선택 탭 숨기기
                    plugins={[colorSyntax, codeSyntaxHighlight]}
                  />
                </div>
                <div className="blog-post-actions" style={{ marginTop: '0px' }}>
                  <button
                    type="button"
                    className="blog-action-btn primary"
                    onClick={() => handleModalAction('insert')}
                  >
                    저장
                  </button>
                  <>
                    <button
                      type="button"
                      className="blog-action-btn user"
                      onClick={() => handleModalAction('cancel')}
                    >
                      취소
                    </button>
                  </>
                </div>
              </form>
            </div>
          </div>
        </>
      )}
    </>
  )
}
